<template>
  <div>
    <v-container fluid class="py-1">
      <v-row no-gutters>
        <v-col cols="$vuetify.breakpoint.mobile?12:2">
          <v-btn-toggle rounded v-model="display" mandatory class="mt-1" @change="query()">
            <v-btn small><v-icon small>mdi-sitemap</v-icon></v-btn>
            <v-btn small><v-icon small>mdi-file-tree</v-icon></v-btn>
          </v-btn-toggle>
        </v-col>
        <v-col cols="3" v-if="display===0 && !$vuetify.breakpoint.mobile">
          <v-slider v-model="zoom" thumb-label hide-details min="25" max="100"
                    append-icon="mdi-magnify-plus-outline"
                    prepend-icon="mdi-magnify-minus-outline"
                    @click:append="() => zoom = (this.zoom + 10) || 100"
                    @click:prepend="() => zoom = (this.zoom - 10) || 0"/>
        </v-col>
        <v-col class="text-right pr-2" v-if="!$vuetify.breakpoint.mobile">
          <v-btn icon @click="print" :disabled="display===0"><v-icon>mdi-printer</v-icon></v-btn>
        </v-col>
      </v-row>
    </v-container>
    <v-divider/>

    <v-card v-show="display===0" height="calc(100vh - 150px)" class="pb-0 text-center" style="overflow:scroll" flat :loading="loading">
      <div style="position:relative;display:inline-block;margin-top:20px"
                  :style="{width:maxWidth*zoom/100+'px',height:maxHeight*zoom/100+'px',transform:'scale('+zoom/100+')',transformOrigin:'left top'}" ref="top">

        <template v-for="node in nodes">
          <span :key="node.id">
            <div v-if="node.parent" style="position:absolute;width:1px;border-right:1px solid #aaa"
                                   :style="{left:(node.x+nodeWidth/2)+'px',top:(node.y-levelSeparation/4)+'px',height:(levelSeparation/4)+'px'}">
              <div :class="{'arrow-down':input.forward}"/>
            </div>
            <template v-if="numberChildren(node)">
              <div style="position:absolute;width:1px;border-right:1px solid #aaa" :style="{left:(node.x+nodeWidth/2)+'px',top:(node.y+nodeHeight-10)+'px',height:(levelSeparation/4+10)+'px'}">
                <div :class="{'arrow-up':!input.forward}" :style="{top:(nodeHeight-nodeHeight+(isAction(node)?0:10))+'px'}"/>
              </div>
              <div style="position:absolute;height:1px;border-bottom:1px solid #aaa" :style="{left:(node.x+nodeWidth/2-childSpan(node)/2)+'px',width:childSpan(node)+'px',top:(node.y+levelSeparation-nodeHeight/2)+'px'}"/>
            </template>

            <v-menu offset-y>
              <template v-slot:activator="{ on:menu }">
                <v-tooltip top open-delay="500">
                  <template v-slot:activator="{ on: tooltip }">
                    <div class="text-caption block-select" v-on="{...menu,...tooltip}" :class="isAction(node)?'action-block':'inventory-block'"
                          :style="{width:nodeWidth+'px',height:nodeHeight-(isAction(node)?10:0)+'px',left:node.x+'px',top:node.y+'px'}">
                      <div class="font-weight-bold mx-2" style="overflow:hidden;text-overflow:ellipsis;white-space:nowrap">{{node.description}}</div>
                      <div>{{node.date | formatDate}}</div>
                      <div style="overflow:hidden;text-overflow:ellipsis;white-space:nowrap">{{node.alcoholName}}</div>
                      <div>{{isAction(node)?'':node.lot}}</div>
                    </div>
                  </template>
                  {{isAction(node)?'':node.refType+': '}}{{node.description}}
                </v-tooltip>
              </template>
              <v-list dense>
                <template>
                  <template v-if="isAction(node)">
                    <v-list-item @click="viewTransaction(node)"><v-list-item-title>Details</v-list-item-title></v-list-item>
                    <v-divider/>
                  </template>
                  <v-list-item @click="forward(node)"><v-list-item-title>Forward trace</v-list-item-title></v-list-item>
                  <v-list-item @click="backward(node)"><v-list-item-title>Backward trace</v-list-item-title></v-list-item>
                </template>
              </v-list>
            </v-menu>

          </span>
        </template>
      </div>
    </v-card>

    <div v-show="display===1" style="height:calc(100vh - 150px);overflow:scroll">
      <v-treeview :items="treeRoot" hoverable ref="tree">
        <template v-slot:prepend="{item}">
          <v-menu offst-y>
            <template v-slot:activator="{ on }">
              <v-icon small v-on="on">{{isAction(item) ? 'mdi-cogs' : 'mdi-widgets'}}</v-icon>
            </template>
            <v-list dense>
              <template>
                <template v-if="isAction(item)">
                  <v-list-item @click="viewTransaction(item)"><v-list-item-title>Details</v-list-item-title></v-list-item>
                  <v-divider/>
                </template>
                <v-list-item @click="forward(item)"><v-list-item-title>Forward trace</v-list-item-title></v-list-item>
                <v-list-item @click="backward(item)"><v-list-item-title>Backward trace</v-list-item-title></v-list-item>
              </template>
            </v-list>
          </v-menu>
        </template>
      </v-treeview>
    </div>

    <v-dialog v-model="showProduct" persistent max-width="600">
      <v-card>
        <v-card-title>Lot trace</v-card-title>
        <v-divider/>
        <v-card-text class="pb-0">
          <v-form ref="lot" v-model="valid">
            <v-container>
              <v-row dense>
                <v-col cols="3" v-if="this.products.length !== 0 && this.items.length !== 0">
                  <v-btn-toggle v-model="type" mandatory @change="input.id = (type===0?products[0].id:items[0].id)" class="mt-1">
                    <v-btn small>Product</v-btn>
                    <v-btn small>Item</v-btn>
                  </v-btn-toggle>
                </v-col>
                <v-col cols="1" v-if="this.products.length !== 0 && this.items.length !== 0"/>
                <v-col v-if="type===0" cols="8">
                  <v-autocomplete :items="products" item-value="id" item-text="name" v-model="input.id" outlined dense/>
                </v-col>
                <v-col v-else cols="8">
                  <v-autocomplete :items="items" item-value="id" item-text="name" v-model="input.id" outlined dense/>
                </v-col>
              </v-row>
              <v-row dense>
                <v-col cols="4" v-if="this.products.length !== 0 && this.items.length !== 0"/>
                <v-col cols="6">
                  <v-text-field label="Lot number" v-model="input.lot" :rules="[fieldRules.required,fieldRules.maxLength(20)]" outlined dense/>
                </v-col>
              </v-row>
            </v-container>
          </v-form>
        </v-card-text>
        <v-divider/>
        <v-card-actions class="pr-6">
          <v-spacer/>
          <v-btn plain color="primary" @click="showProduct=false;$router.back()">Cancel</v-btn>
          <v-btn color="primary" @click="input.forward = type===1;refresh(true)">Show</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

  </div>
</template>

<style scoped>
.action-block {
  position:absolute;
  border:1px solid #64b5f6;
  background-color:#64b5f6;
  color:#000000de;
  border-radius:25px;
  margin-bottom:15px;
}
.inventory-block {
  position:absolute;
  border:1px solid #2196f3;
  color:#2196f3;
  border-radius:4px;
  margin-bottom:15px;
  background-color: #fff;
}
.inventory-block:hover {
  background-color:#f4faff;
  cursor:pointer;
}
.action-block:hover {
  background-color:#4d97e0;
  cursor:pointer;
}
.arrow-down {
  position:absolute;
	width: 0;
	height: 0;
	border-left: 6px solid transparent;
	border-right: 6px solid transparent;
	border-top: 6px solid #aaa;
  top:23px;
  left:-6px;
}
.arrow-up {
  position:absolute;
	width: 0;
	height: 0;
	border-left: 6px solid transparent;
	border-right: 6px solid transparent;
	border-bottom: 6px solid #aaa;
  left:-6px;
}
</style>

<script>
import viewTransaction from '@/mixins/viewTransaction'
import printHtml from '@/mixins/printHtml'

export default {
  name: 'ReportsLot',
  mixins: [viewTransaction,printHtml],
  data() {
    return {
      loading: true,
      zoom: 100,
      input: {
        id:0,
        lot: '',
        forward: null
      },
      treeRoot: [],
      lines: [],
      display: 0,
      products: [],
      items: [],
      showProduct: false,
      type: 0,
      valid: false,

      levelZeroNode: null,
      prevAtLevel: [],
      lowestX: 0,
      maxWidth: 0,
      maxHeight: 0,
      levelSeparation: 120,
      siblingSeparation: 20,
      subtreeSeparation: 20,
      nodeWidth: 150,
      nodeHeight: 60,
      nodes: [],
    }
  },
  computed: {
    direction() {
      if (this.input.forward == null)
        return ''
      return `- ${this.input.forward ? 'forward' : 'backward'}`;
    }
  },
  async created() {
    this.$emit('name', 'Lot tracing');
    if (!this.$route.query.id) {
      await Promise.all([
        this.$lazyListLoad(this.products, 'products2', 'id,name', 100, [{field:'active', comparator:'eq', value:'true'}]),
        this.$lazyListLoad(this.items, 'items2', 'id,name', 100, [{field:'active', comparator:'eq', value:'true'},{field:'lotTracking', comparator:'eq', value:'true'}])
      ]);
      if (this.products.length === 0 && this.items.length === 0) {
        this.$store.commit('setError', {message:'No items or products to trace',type:'warning'})
        this.$router.back();
        return;
      }
      if (this.products.length === 0)
        this.type = 1;
      this.input.id = (this.type === 0 ? this.products[0].id : this.items[0].id);

      this.showProduct = true;
    }
    else {
      this.input.id = this.$route.query.id;
      this.input.lot = this.$route.query.lot;
      this.input.forward = this.$route.query.forward == 1;
      if (this.$route.query.display)
        this.display = parseInt(this.$route.query.display);
      this.refresh(false);
    }
  },

/*
http://www.cs.unc.edu/techreports/89-034.pdf
*/

  methods: {
    query() {
      this.$router.replace({query: {to:'reports/inventory/ReportsLot',id:this.input.id,lot:this.input.lot,forward:this.input.forward?1:0,display:this.display}});
    },
    forward(node) {
      if ((node.lot || this.isAction(node)) && (this.input.id !== node.refId || this.input.lot !== node.lot || !this.input.forward)) {
        this.input = {id:node.refId,lot:node.lot,forward:true};
        this.query();
        this.refresh(false);
      }
    },
    backward(node) {
      if ((node.lot || this.isAction(node)) && (this.input.id !== node.refId || this.input.lot !== node.lot || this.input.forward)) {
        this.input = {id:node.refId,lot:node.lot,forward:false};
        this.query();
        this.refresh(false);
      }
    },
    isAction(node) {
      if (node.refType === 'Item' || node.refType === 'Product' || node.refType === 'Bundle' ||
          node.refType === 'Fermenter' || node.refType === 'Tank' || node.refType === 'Cask')
        return false;
      return true;
    },
    childSpan(node) {
      if (!node.firstChild)
        return 0;
      const left = node.firstChild.x;
      let right = left;
      for (let child = node.firstChild; child; child = child.rightSibling)
        right = child.x;
      return right - left;
    },
    numberChildren(node) {
      let n = 0;
      for (let child = node.firstChild; child; child = child.rightSibling)
        n++;
      return n;
    },
    addTreeNode(node) {
      // Find each child node
      // eslint-disable-next-line no-unused-vars
      const {children, description, date, ...newNode} = node;
      newNode.children = [];
      if (this.isAction(node))
        newNode.name = `${node.description} ${this.$formatDate(node.date)}`;
      else
        newNode.name = `${node.description}${node.alcoholName ? ` - ${node.alcoholName}` : ''}${node.lot?`, Lot ${node.lot}`:''}`;

      node.children.forEach(child => {
        const childNode = this.lines.find(n => n.id === child);
        const newChildNode = this.addTreeNode(childNode);
        newNode.children.push(newChildNode);
      });
      return newNode;
    },
    async refresh(explicit) {
      if (explicit) {
        if (!this.valid)
          return;
        this.showProduct = false
      }
      this.loading = true;

      const results = await this.$apiCall(`query ReportsLot($input:LotReportInput!) {
                                            lotReport(input:$input) {
                                              id,description,date,alcoholName,lot,children,refType,refId
                                            }
                                          }`,
                                          {input:this.input});
      if (!results.error) {
        this.lines = results.data.lotReport;
        this.treeRoot = [this.addTreeNode(this.lines[0])];
        this.$nextTick(() => this.$refs.tree?.updateAll(true));

        const list = this.lines;
        const tree = this.buildBasicTree(list[0], list);
        const apex = this.buildSubTree(tree, null);

        this.positionTree(apex);
        this.nodes = [];
        this.nodeList(apex);
        this.maxWidth += this.nodeWidth  - this.lowestX + 30;
        this.maxHeight += this.nodeHeight + 20;

        this.$refs.top?.scrollIntoView();
      }
      this.loading = false;
    },
    nodeList(node) {
      node.x += -this.lowestX + 15;
      this.nodes.push(node);
      let child = node.firstChild;
      while (child) {
        this.nodeList(child);
        child = child.rightSibling;
      }
    },
    buildBasicTree(node, list) {
      // eslint-disable-next-line no-unused-vars
      const {children, ...basicNode} = node;
      basicNode.children = [];

      for (const id of node.children) {
        const n = list.find(n => n.id === id);
        basicNode.children.push(this.buildBasicTree(n, list));
      }

      return basicNode;
    },
    buildSubTree(node, parent) {
      const treeNode = {id:node.id,description:node.description,lot:node.lot,date:node.date,alcoholName:node.alcoholName,refType:node.refType,refId:node.refId,
                        parent, firstChild:null, leftSibling:null, rightSibling:null,
                        x:0,y:0,prelim:0,modifier:0,leftNeighbor:null};
      // Need to build sub trees (recursively) for each child of this node
      const length = node.children.length;
      if (length) {
        const list = [];
        for (let i = 0; i < length; i++)
          list.push(this.buildSubTree(node.children[i], treeNode));

        // Now that we have subtree for each node, set references for this node (the parent) to sub tree
        treeNode.firstChild = list[0];
        for (let i = 0; i < length; i++) {
          list[i].leftSibling = (i === 0 ? null : list[i-1]);
          list[i].rightSibling = (i === length-1 ? null : list[i+1]);
        }
      }

      return treeNode;
    },
    positionTree(node) {
      if (!node)
        return;

      this.maxWidth = 0;
      this.maxHeight = 0;
      this.lowestX = 0;
      this.levelZeroNode = null;
      this.prevAtLevel = [];

      this.firstWalk(node, 0); // Do the preliminary positianing with a postorder wa1k

      this.secondWalk(node, 0, 0); // Do the final positioning with a preorder walk.
    },

    firstWalk(node, level) {
      // Set the pointer to the previous node at this level
      this.prevAtLevel.length = Math.max(level,this.prevAtLevel.length);   // Make sure array is of sufficient length
      node.leftNeighbor = this.prevAtLevel[level];
      this.prevAtLevel[level] = node;
      node.modifier = 0;
      if (!node.firstChild /*|| level === this.maxDepth */) {
        // Determine the preliminary x-coordinate based on:
        //    the preliminary x-coordinate of the left sibling
        //    the separation between sibling nodes, and
        //    the mean size of left sibling and current node
        if (node.leftSibling)
          node.prelim = node.leftSibling.prelim + this.siblingSeparation + this.nodeWidth; //  this.meanNodeSize(node.leftSibling, node);
        else
          node.prelim = 0;
      }
      else {
        // This Node is not a leaf, so call this procedure recursively for each of its offspring
        let leftMost = node.firstChild;
        let rightMost = leftMost;
        this.firstWalk(leftMost, level+1);
        while (rightMost.rightSibling) {
          rightMost = rightMost.rightSibling;
          this.firstWalk(rightMost, level+1);
        }
        let midPoint = (leftMost.prelim + rightMost.prelim) / 2;
        if (node.leftSibling) {
          node.prelim = node.leftSibling.prelim + this.siblingSeparation + this.nodeWidth; // this.meanNodeSize(node.leftSibling, node);
          node.modifier = node.prelim - midPoint;
          this.apportion2(node);
        }
        else
          node.prelim = midPoint;
      }
    },
    secondWalk(node, level, modSum) {
      node.x = node.prelim + modSum;
      node.y = level * this.levelSeparation;

      this.lowestX = Math.min(this.lowestX, node.x);
      this.maxWidth = Math.max(this.maxWidth, node.x);
      this.maxHeight = Math.max(this.maxHeight, node.y)

      if (node.firstChild)    // Apply the modifier value for this node to all its offspring
        this.secondWalk(node.firstChild, level+1, modSum + node.modifier);
      if (/*result && */node.rightSibling)
        this.secondWalk(node.rightSibling, level, modSum);
    },
    apportion(node /*, level*/) {
      let leftMost = node.firstChild;
      let neighbor = leftMost.leftNeighbor;
      let compareDepth = 1;

      while (leftMost && neighbor /*&& compareDepth <= depthToStop */) {

        // Compute the location of Leftmost and where it should be with respect to Neighbor
        let leftModSum = 0;
        let rightModSum = 0;
        let ancestorLeftMost = leftMost;
        let ancestorNeighbor = neighbor;
        for (let i = 0; i < compareDepth; i++) {
          ancestorLeftMost = ancestorLeftMost.parent;
          ancestorNeighbor = ancestorNeighbor.parent;
          rightModSum += ancestorLeftMost.modifier;
          leftModSum += ancestorNeighbor.modifier;
        }

        // Find the moveDistance, and apply it to Node's subtree.
        // Add appropriate portions to smaller interior subtrees.
        let moveDistance = (neighbor.prelim + leftModSum + this.subtreeSeparation + this.nodeWidth /*this.meanNodeSize(leftMost, neighbor)*/) - (leftMost.prelim + rightModSum);
        if (moveDistance > 0) {
          // Count interior sibling subtrees in LeftSiblings
          let temp = node;
          let leftSiblings = 0;
          while (temp && temp !== ancestorNeighbor) {
            leftSiblings++;
            temp = temp.leftSibling;
          }
          if (temp) {
            // Apply portions to appropriate leftsibling subtrees
            let portion = moveDistance / leftSiblings;
            temp = node;
            while (temp && temp !== ancestorNeighbor) {
              temp.prelim += moveDistance;
              temp.modifier += moveDistance;
              moveDistance -= portion;
              temp = temp.leftSibling;
            }
          }
          else
            // Don't need to move anything--it needs to be done by an ancestor because
            // AncestorNeighbor and AncestorLeftmost are not siblings of each other
            return;
        }

        // Determine the leftmost descendant of Node at the next lower level to compare its positioning against that of its Neighbor
        compareDepth++;
        if (!leftMost.firstChild)
          leftMost = this.getLeftMost(node, 0, compareDepth);
        else
          leftMost = leftMost.firstChild;
        if (leftMost)
          ancestorNeighbor = leftMost.leftNeighbor;
      }
    },

    apportion2(node) {
      let leftMost = node.firstChild;
      let neighbor = leftMost.leftNeighbor;
      let compareDepth = 1;

      while (leftMost && neighbor) {
        let leftModSum = 0;
        let rightModSum = 0;
        let leftMostAncestor = leftMost;
        let neighborAncestor = neighbor;

        /*(* Compute the location of Leftmost and where it should *)
          (* be with respect to Neighbor. *)*/

        for (let i = 0; i < compareDepth; i++) {
            leftMostAncestor = leftMostAncestor.parent;
            neighborAncestor = neighborAncestor.parent;
            rightModSum += leftMostAncestor.modifier;
            leftModSum += neighborAncestor.modifier;
        }
        /*(* Find the moveDistance, and apply it to Node's subtree. *)
          (*Add appropriate portions to smaller interior subtrees. *)*/

        let distance = neighbor.prelim + leftModSum + this.subtreeSeparation + this.nodeWidth - (leftMost.prelim + rightModSum);
        //(*Count interior sibling subtrees in LeftSiblings*)//
        if (distance > 0) {
          let leftSiblings = 0;
          let tempNode = node;
          while (tempNode && tempNode !== neighborAncestor) {
            leftSiblings++;
            tempNode = tempNode.leftNeighbor;
          }

          if (tempNode) {
            const proportion = distance / leftSiblings;
            for (tempNode = node; tempNode && tempNode !== neighborAncestor; tempNode = tempNode.leftNeighbor) {
              tempNode.prelim += distance;
              tempNode.modifier += distance;
              distance -= proportion;
            }
          }
          else
            /*(* Don't need to move anything--it needs to *)
              (* be done by an ancestor because *)
              (* AncestorNeighbor and AncestorLeftmost are *)
              (* not siblings of each other. *)*/
            return;
        }
        compareDepth++;
        // (* Determine the leftmost descendant of Node at the next *)
        // (* lower level to compare its positioning against that of its neighbor*)
        if (!leftMost.firstChild)
          leftMost = this.getLeftMost(node, 0, compareDepth);
        else
          leftMost = leftMost.firstChild;
        if (leftMost)
          neighbor = leftMost.leftNeighbor;
      }
    },

    getLeftMost(node, level, depth) {
      if (level === depth)
        return node;
      if (!node.firstChild)
        return null;

      let rightMost = node.firstChild;
      let leftMost = this.getLeftMost(rightMost, level+1, depth);

      // Do a postorder walk of the subtree below Node
      while (!leftMost && rightMost.rightSibling) {
        rightMost = rightMost.rightSibling;
        leftMost = this.getLeftMost(rightMost, level+1, depth);
      }

      return leftMost;
    },

    print() {
      const lines = [`
        <style>
          @page {size:portrait}
          .reports-lot {font-family: Roboto, sans-serif; width:100%;border-spacing:0;font-size:12px}
          .reports-lot th {height:36px;padding-bottom:24px}
          .reports-lot td {height:24px}
          .reports-lot .title {font-size:18px;text-transform:uppercase}
          .reports-lot .sup-title {font-weight:normal;font-size:22px}
        </style>
        <table class="reports-lot">
          <thead>
            <tr>
              <th class="sup-title">${this.$store.getters.company.name}</th>
            </tr>
            <tr>
              <th class="title">Lot tracing - ${this.input.forward ? 'forward' : 'backward'}</div></th>
            </tr>
          </thead>
          <tbody>`];
      this.printLine(lines, this.treeRoot[0], 0);
      lines.push(`</tbody></table>`)

      this.printHtml('Lot trace',lines.join(''));
    },
    printLine(lines, node, level) {
      lines.push(`<tr><td style="text-indent:${level*20}px">${node.name}</td></tr>`);
      node.children.forEach(child => {this.printLine(lines, child, level+1)});
    }
  }
}
</script>